export default "__VITE_ASSET__1b679a5e__"